module.exports = __webpack_public_path__ + "media/packs/images/flags/FR-75dbc6413741b7babd568ad631ee1006.png";